(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["resource-list-carousel"] && !Shopify.designMode) return;
  try {
    (function() {
  function initCarouselDots(wrapper) {
    var dotsContainer = wrapper.querySelector('.prd-carousel-dots');
    if (!dotsContainer) return;

    var slidesEl = wrapper.querySelector('slideshow-slides');
    if (!slidesEl) return;

    var dots = dotsContainer.querySelectorAll('.prd-carousel-dot');

    function getActiveDotIndex() {
      var scrollLeft = slidesEl.scrollLeft;
      var maxScroll = slidesEl.scrollWidth - slidesEl.clientWidth;
      if (maxScroll <= 0) return 0;

      // Which dot bucket does current scroll position fall into?
      var ratio = scrollLeft / maxScroll;
      var index = Math.round(ratio * (dots.length - 1));
      return Math.min(index, dots.length - 1);
    }

    function updateDots() {
      var active = getActiveDotIndex();
      dots.forEach(function(dot, i) {
        dot.classList.toggle('prd-carousel-dot--active', i === active);
      });
    }

    // Sync on scroll
    slidesEl.addEventListener('scroll', updateDots, { passive: true });

    // Dot click — scroll to proportional position
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        var maxScroll = slidesEl.scrollWidth - slidesEl.clientWidth;
        var targetScroll = (i / (dots.length - 1)) * maxScroll;
        slidesEl.scrollTo({ left: targetScroll, behavior: 'smooth' });
      });
    });

    // Initial state
    updateDots();
  }

  function init() {
    document.querySelectorAll('.prd-carousel-wrapper').forEach(function(wrapper) {
      var slidesEl = wrapper.querySelector('slideshow-slides');
      if (slidesEl) {
        initCarouselDots(wrapper);
      } else {
        var mo = new MutationObserver(function(_, obs) {
          var el = wrapper.querySelector('slideshow-slides');
          if (el) {
            obs.disconnect();
            initCarouselDots(wrapper);
          }
        });
        mo.observe(wrapper, { childList: true, subtree: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
